var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.293 0.292969C16.6835 -0.0975248 17.3166 -0.0975469 17.7071 0.292969C18.0976 0.683483 18.0976 1.31651 17.7071 1.70703L10.3829 9.03027L17.6456 16.293C18.0358 16.6834 18.0357 17.3165 17.6456 17.707C17.2551 18.0975 16.622 18.0975 16.2315 17.707L8.9688 10.4443L1.7686 17.6455C1.37805 18.0357 0.744956 18.0359 0.354538 17.6455C-0.0357924 17.2551 -0.0356354 16.622 0.354538 16.2314L7.55473 9.03027L0.293015 1.76953C-0.0975074 1.379 -0.0975074 0.745019 0.293015 0.354492C0.683475 -0.0356644 1.31663 -0.0356857 1.70708 0.354492L8.9688 7.61621L16.293 0.292969Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconX);
export default __webpack_public_path__ + "static/media/icon-x.da21e2e676de4ebeba9dcc27516bd935.svg";
export { ForwardRef as ReactComponent };